import { API_ROUTES } from '@/constants';
import {
  AiresFileData,
  AiresFilesIds,
  AiresFilesResponse,
  AiresFilesStatusesResponse,
  AiresValidationResponse,
  AssignMappingDataItem,
  IsAiresEmptyResponse,
  MappingDataResponse,
  MappingResponse,
  MappingStatusResponse,
  MappingTypeItemBody,
  OSType,
  PfcMappingDataResponse,
  ServerResponse,
  UploadFunctionResponse,
  PFCMeaningResponse,
  PfcRowRequestItem,
  PfcDefinitionParams,
  PfcMappingRow,
  UploadHistoryResponse,
  UiStatusResponse,
  UiStatusType,
  UiStatusUpdateRequest,
} from '@/types';

import { apiServices } from './services';

const { dataManagementApiService, uiStatusApiService } = apiServices;

const FILE_UPLOAD_HEADERS = {
  'Content-Type': 'multipart/form-data',
};

export const getCuInfo = async () => dataManagementApiService.get(API_ROUTES.INFO);

export const getDataPrepareDownloadStatus = (osType?: OSType) =>
  dataManagementApiService.get(`${API_ROUTES.DATA_PREPARER_INFO}${osType}`);

export const getDataPrepareInfo = () => dataManagementApiService.get(API_ROUTES.DATA_PREPARER_VERSION);

export const getIsAreaEmpty = (): Promise<IsAiresEmptyResponse> =>
  dataManagementApiService.get(API_ROUTES.AIRES_FILES_IS_EMPTY);

export const getSubmissionData = () => dataManagementApiService.get(API_ROUTES.GET_SUBMISSIONS);

export const uploadFilesData = (data: FormData): Promise<UploadFunctionResponse> =>
  dataManagementApiService.post(API_ROUTES.UPLOAD_FILES, data, { headers: { ...FILE_UPLOAD_HEADERS } });

export const getAiresFilesData = (params: string): Promise<AiresFilesResponse> =>
  dataManagementApiService.get(API_ROUTES.AIRES_DATA + params);

export const deleteSubmissionRow = (submissionId: AiresFileData['submissionId']) =>
  dataManagementApiService.delete(`${API_ROUTES.DELETE_SUBMISSION}/${submissionId}`);

export const fetchAiresStatuses = (submissionIds: AiresFilesIds): Promise<AiresFilesStatusesResponse> =>
  dataManagementApiService.post(API_ROUTES.AIRES_FILES_STATUSES, submissionIds);

export const getDataQualityReport = (submissionId: AiresFileData['submissionId']): Promise<AiresValidationResponse> =>
  dataManagementApiService.get(`${API_ROUTES.DATA_REPORT}?submissionId=${submissionId}`);

export const getAiresMappingStatus = (): Promise<MappingStatusResponse> =>
  dataManagementApiService.get(API_ROUTES.MAPPING_STATUS);

export const fetchLoansMappingData = (searchParams: string): Promise<MappingDataResponse> =>
  dataManagementApiService.get(API_ROUTES.GET_LOANS_MAPPING_DATA + searchParams);

export const fetchLoansTypes = (): Promise<MappingResponse> => dataManagementApiService.get(API_ROUTES.GET_LOAN_TYPES);

export const saveLoansType = (type: MappingTypeItemBody): Promise<ServerResponse<string>> =>
  dataManagementApiService.post(API_ROUTES.SAVE_LOAN_TYPE, type);

export const fetchSharesMappingData = (searchParams: string): Promise<MappingDataResponse> =>
  dataManagementApiService.get(API_ROUTES.GET_SHARES_MAPPING_DATA + searchParams);

export const fetchSharesTypes = (): Promise<MappingResponse> =>
  dataManagementApiService.get(API_ROUTES.GET_SHARES_TYPES);

export const saveShareType = (type: MappingTypeItemBody): Promise<ServerResponse<string>> =>
  dataManagementApiService.post(API_ROUTES.SAVE_SHARE_TYPE, type);

export const changeLoanMappingData = (selectedLoanIds: AssignMappingDataItem[]) =>
  dataManagementApiService.post(API_ROUTES.ASSIGN_LOAN_TYPES, selectedLoanIds);

export const changeShareMappingData = (selectedShareIds: AssignMappingDataItem[]) =>
  dataManagementApiService.post(API_ROUTES.ASSIGN_SHARE_TYPES, selectedShareIds);

export const savePrefilledTemplate = (url: string, data: FormData): Promise<ServerResponse<string>> =>
  dataManagementApiService.post(url, data, { headers: { ...FILE_UPLOAD_HEADERS } });

export const fetchPfcMappingData = (searchParams: string): Promise<PfcMappingDataResponse> =>
  dataManagementApiService.get(API_ROUTES.GET_PFC_MAPPING_DATA + searchParams);

export const fetchPfcMeaningData = (): Promise<PFCMeaningResponse> =>
  dataManagementApiService.get(API_ROUTES.PFC_MEANING_DATA);

export const savePfcRow = (row: PfcRowRequestItem) => dataManagementApiService.post(API_ROUTES.PFC_EDIT_ROW, row);

export const savePfcRows = (rows: PfcMappingRow[]) => dataManagementApiService.post(API_ROUTES.PFC_EDIT_ROWS, rows);

export const savePfcDefinition = (params: PfcDefinitionParams): Promise<ServerResponse<string>> =>
  dataManagementApiService.post(API_ROUTES.SAVE_PFC_DEFINITION, params);

export const getSubmissionHistory = (params: string): Promise<UploadHistoryResponse> =>
  dataManagementApiService.get(API_ROUTES.SUBMISSION_HISTORY + params);

export const getUiStatus = async (uiStatusType: UiStatusType): Promise<UiStatusResponse> => {
  const response = await uiStatusApiService.get<UiStatusResponse>(API_ROUTES.UI_STATUS_GET_STATUS, {
    params: { uiStatusType },
  });

  return response.data;
};

export const updateUiStatus = async (body: UiStatusUpdateRequest): Promise<UiStatusResponse> => {
  const response = await uiStatusApiService.post<UiStatusResponse>(API_ROUTES.UI_STATUS_UPDATE_STATUS, body);

  return response.data;
};
